import Swiper from 'swiper/bundle';
import { A11y, Pagination } from 'swiper/modules';

window.Testimonials = () => {
	return {
		swiper: null,
		init() {
			setTimeout(() => {
				this.swiper = new Swiper(this.$refs.swiperContainer, {
					modules: [A11y, Pagination],
					a11y: true,
					loop: true,
					grabCursor: true,
					slidesPerView: 1,
					pagination: {
						el: this.$refs.swiperPagination,
						clickable: true,
						// type: 'bullets',
						renderBullet: function (index, className) {
							return '<div class="' + className + '"><div class="dot"></div></div>'
						}
					},
				});
			}, 0);
		},
	};
};
